class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting || !this.dataset.url) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              document.dispatchEvent(
                new CustomEvent('initCarousel', {
                  detail: {
                    key: 'product-recommendations',
                  },
                }),
              );
            }
          })
          .catch((e) => {
            console.error(e);
          });
      },
      { rootMargin: '0px 0px 400px 0px' },
    );

    observer.observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
